import { Reducer } from "redux";

import {
    TOPIC_INFO_FETCH_FAILURE,
    TOPIC_INFO_FETCH_REQUEST,
    TOPIC_INFO_FETCH_SUCCESS,
    TOPIC_INVITE_MODERATOR_SUCCESS,
    TOPIC_REMOVE_MODERATOR_SUCCESS,
    TopicInfoFetchFailureAction,
    TopicInfoFetchRequestAction,
    TopicInfoFetchSuccessAction,
    TopicInviteModeratorSuccessAction,
    TopicRemoveModeratorSuccessAction,
} from "@/mk2/apps/forum/containers/TopicInfo/TopicInfo.actions";
import { initialTopicInfoState } from "@/mk2/apps/forum/containers/TopicInfo/TopicInfo.constants";
import { tupdate } from "@/mk2/helpers/types";
import { errorMessage } from "@/mk2/reducers/errorMessage";
import { LoadingState, loadingState } from "@/mk2/reducers/loadingState";

export interface TopicInfoState {
    topicId: number | null;
    loadingState: LoadingState;
    errorMessage: string;
    moderatorsDetailsId: number;
}

export interface TopicInfosState {
    [topicSlug: string]: TopicInfoState;
}

const initialTopicInfosState: TopicInfosState = {};

declare type TopicInfosReducerAction =
    | TopicInfoFetchRequestAction
    | TopicInfoFetchSuccessAction
    | TopicInfoFetchFailureAction
    | TopicInviteModeratorSuccessAction
    | TopicRemoveModeratorSuccessAction;

const topicInfosReducer: Reducer<TopicInfosState> = (
    state = initialTopicInfosState,
    action: TopicInfosReducerAction,
) => {
    switch (action.type) {
        case TOPIC_INFO_FETCH_REQUEST:
        case TOPIC_INFO_FETCH_FAILURE: {
            const topicSlug = action.topicSlug;
            return tupdate(state, {
                [topicSlug]: tupdate(state[topicSlug] || initialTopicInfoState, {
                    loadingState: loadingState(undefined, action),
                    errorMessage: errorMessage(undefined, action),
                }),
            });
        }

        case TOPIC_INFO_FETCH_SUCCESS:
        case TOPIC_INVITE_MODERATOR_SUCCESS:
        case TOPIC_REMOVE_MODERATOR_SUCCESS: {
            const topicSlug = action.topicSlug;
            return tupdate(state, {
                [topicSlug]: tupdate(state[topicSlug] || initialTopicInfoState, {
                    topicId: action.response.result.topic,
                    loadingState: loadingState(undefined, action),
                    errorMessage: errorMessage(undefined, action),
                    moderatorsDetailsId: action.response.result.moderatorsDetails,
                }),
            });
        }

        default:
            return state;
    }
};

export default topicInfosReducer;
